import mixpanel from 'mixpanel-browser';

export const initMixpanel = () => {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_KEY, {
    debug: process.env.NODE_ENV !== 'production',
    track_pageview: true,
    persistence: 'localStorage'
  });
};

export const identifyMixpanel = (userId, userProperties = {}) => {
  mixpanel.identify(userId);
  mixpanel.people.set(userProperties);
};

export const trackMixpanel = (eventName, properties = {}) => {
  mixpanel.track(eventName, properties);
};

export default { initMixpanel, identifyMixpanel, trackMixpanel };
